import { types } from './actions';

const initialState = {
  accountId: null,
  isDeletingAccount: false,
  isLoadingAccount: false,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.ACCOUNT_DETAILS_INIT:
      return {
        ...state,
        accountId: payload.accountId,
        isLoadingAccount: true,
      };
    case types.DELETE_ACCOUNT_ERROR:
    case types.DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        isDeletingAccount: false,
      };
    case types.DELETE_ACCOUNT_REQUEST:
      return {
        ...state,
        isDeletingAccount: true,
      };
    case types.FETCH_ACCOUNT_ERROR:
    case types.FETCH_ACCOUNT_SUCCESS:
      return {
        ...state,
        isLoadingAccount: false,
      };
    case types.FETCH_ACCOUNT_REQUEST:
      return {
        ...state,
        isLoadingAccount: true,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.contacts.accountDetails.app;

export const getAccountId = (state) => getScope(state).accountId;

export const getIsDeletingAccount = (state) =>
  getScope(state).isDeletingAccount;

export const getIsLoadingAccount = (state) => getScope(state).isLoadingAccount;

export default reducer;
